export default __webpack_public_path__ + "static/icons-01-01-baf1d0d99d0b5f609afe413964006449.png";